import React, { useCallback, useMemo } from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import i18n from "i18next";
import { getLanguageSelectionOptions, normalizeLanguageCode, SUPPORTED_LANGUAGE_TAGS } from "../../utils/languageUtils";
import { useTranslation } from "react-i18next";

/**
 * Reusable language selector component
 * Displays a dropdown with available languages
 */
const LanguageSelector = ({ color = "common.white" }) => {
    const { i18n: i18nInstance } = useTranslation();
    const lang = normalizeLanguageCode(i18nInstance.language);
    const languageOptions = useMemo(() => {
        const displayLocale = lang || i18n.language;
        return getLanguageSelectionOptions(displayLocale, SUPPORTED_LANGUAGE_TAGS);
    }, [lang]);

    const handleChangeLocale = useCallback((locale) => {
        i18n.changeLanguage(locale);
    }, []);

    return (
        <FormControl variant="standard">
            <Select
                disableUnderline
                id="language-select"
                value={lang || ""}
                label="Language"
                onChange={(e) => handleChangeLocale(e.target.value)}
                sx={{
                    color: color,
                    "& .MuiSelect-icon": {
                        color: color,
                    },
                }}
            >
                {languageOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.text}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
